import sdl from '@jds/react-generated-sdl/JDSMenuBlock';
import type { JDSMenuBlockProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, MenuBlockProps } from '../logic';

const Component = (props: MenuBlockProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const { open = false, custom = '', ...rest } = props as any;
  return createComponent(
    json,
    { open, ...rest },
    'JDSMenuBlock',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const MenuBlock = withLogic(Component) as React.FC<MenuBlockProps> & {
  slotName?: string;
};

MenuBlock.displayName = 'MenuBlock';
MenuBlock.slotName = 'jds_menu_block';

export { MenuBlock, type JDSMenuBlockProps };
